<template>
  <div class="upload-list">
    <div class="upload-header">
      <i class="upload-icon" :class="{ uploading: uploading > 0 }"></i>
      <div class="upload-info" v-show="uploading > 0">
        <span>{{ uploading }}/{{ list.length }}项任务进行中</span>
        <p>上传中</p>
      </div>
      <h3 class="title" v-show="uploading === 0">上传已完成</h3>
      <el-button size="small" class="security" @click="security" v-show="uploading === 0">保密操作</el-button>
      <el-button size="small" @click="close" v-show="uploading === 0">关闭</el-button>
    </div>

    <div class="upload-main">
      <div class="list">
        <div class="upload-item" v-for="(item, index) in list" :key="index">
          <div class="item-info">
            <i class="icon"></i>
            <div class="file-info">
              <div class="desc">
                <p class="name" :title="item.name">{{ item.name }}</p>
                <span>
                  {{ changeByte(item.size) }}
                  <em v-if="item.fail">文件上传失败</em>
                </span>
              </div>
              <i class="icon fail" v-if="item.fail"></i>
              <i class="icon success" v-if="item.success"></i>
              <p class="status" v-if="!item.fail && !item.success">{{ item.process }}%</p>
            </div>
          </div>
          <div class="process-box">
            <i class="process" :style="{ width: item.process + '%' }"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { changeByte } from "../assets/js/tools";
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  watch: {
    list: {
      handler(val) {
        this.list = val;
      },
      deep: true
    }
  },
  data() {
    return {};
  },
  computed: {
    uploading() {
      return this.list.filter(it => !it.fail && !it.success).length;
    }
  },
  methods: {
    security() {
      this.$emit("security");
    },
    changeByte(byte) {
      return changeByte(byte);
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-list {
  width: 452px;
  height: 390px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  position: fixed;
  right: 20px;
  bottom: 20px;

  background-color: #fff;

  .upload-header {
    padding: 30px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #dcdfe6;
    position: relative;

    .el-button {
      position: absolute;
      right: 20px;
      top: 20px;

      &.security {
        right: 86px;
      }
    }

    .upload-icon {
      width: 52px;
      height: 52px;
      background: url(../assets/images/upload-icon.png) no-repeat center center;
      margin-right: 20px;
      &.uploading {
        background: url(../assets/images/uploading.gif) no-repeat center center;
      }
    }

    h3.title {
      color: #000;
      font-size: 30px;
      font-weight: 400;
      margin: 0;
    }

    .upload-info {
      span {
        color: #909399;
      }
      p {
        color: #000;
        font-size: 20px;
        margin: 0;
        text-align: left;
        line-height: 28px;
      }
    }
  }

  .upload-main {
    height: 284px;
    overflow-y: auto;
    .list {
      padding: 20px;
      .upload-item {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .item-info {
          display: flex;
          justify-content: flex-start;
          .icon {
            width: 26px;
            height: 30px;
            background: url(../assets/images/file-icon.png) no-repeat center
              center;
            margin-right: 20px;
          }

          .file-info {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .icon {
              width: 20px;
              height: 20px;
              background: url(../assets/images/upload-fail-icon.png) no-repeat
                center center;
              margin-right: 0;

              &.success {
                background: url(../assets/images/upload-success-icon.png)
                  no-repeat center center;
              }
            }

            p {
              margin: 0;
            }

            .desc {
              font-size: 12px;
              color: #606266;
              text-align: left;
              max-width: 300px;

              p.name {
                margin-bottom: 2px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 300px;
              }
              span {
                color: #909399;
                em {
                  font-style: normal;
                  color: #f5222d;
                  margin-left: 5px;
                }
              }
            }
          }
        }
        .process-box {
          background-color: #ebeef5;
          width: 100%;
          height: 4px;
          border-radius: 2px;
          margin-top: 10px;
          i {
            width: 30%;
            display: block;
            border-radius: 2px;
            height: 4px;
            background-color: #1983f9;
          }
        }
      }
    }
  }
}
</style>